var _            = require('underscore');
var $            = require('jquery');
var Core         = require('../core/core.js');

/**
 * Creates an overlay tray
 *
 * @class
 */

class TrayTabSwitch extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'title': 'no title'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
        <div class='editor__tray__tabs__top__switch'>
            <a class='js-editor__tray__tab__switch__item' data-switchitem='grid'>
                <%= embedded_svg("icon-grid") %>
            </a>
            <a class='js-editor__tray__tab__switch__item' data-switchitem='list'>
                <%= embedded_svg("icon-list") %>
            </a>
        </div>`;

        super.render();

        /**
         * Click
         *
         * @fires TrayTabSwitch#_clicked
         */

         $('.js-editor__tray__tab__switch__item', this.$el).on('click', this._clicked);
    }

    /**
     * @event TrayTabSwitch#Cioui:TrayTabSwitch:clicked
     * @property {String}Cioui:TrayTabSwitch:clicked
     * @returns {String} item clicked
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabSwitch:clicked', $(e.currentTarget).data('switchitem'));
    }

    /**
     * Show the tray tab
     */
    showItem(itemString){
        if(itemString) $('[data-switchitem='+itemString+']', this.$el).show();
    }

    /**
     * Hide all items
     */
    hideAllItems(){
        $('.js-editor__tray__tab__switch__item', this.$el).each(function(){
            $(this).hide();
        })
    }

    /**
     * Show the tray tab
     */
    show(){
        this.$el.show();
    }

    /**
     * Hide the tray tab
     */
    hide(){
        this.$el.hide();
    }

}
module.exports = TrayTabSwitch;